import { FAIcon } from 'shared'
import { SmartButtonController } from 'controllers'
import ChatController from 'controllers/ChatController'
import ChatMessage from './ChatMessage'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'


const ChatMessages = ({ messages, postImage, postLocation, postMessage, userRequest }) => {
  const inputRef = useRef(null)
  const renderedMessagesCountRef = useRef(0)
  const scrollBoxRef = useRef(null)
  const uploadInputRef = useRef(null)

  useEffect(() => {
    scrollToBottom()
  }, [])

  useEffect(() => {
    if (renderedMessagesCountRef.current != messages.length)
      scrollToBottom()
  })

  const submitInput = () => {
    if (userRequest.inputButton) {
      runServerAction()
    } else {
      postNewMessage()
    }
  }

  const runServerAction = async () => {
    let { inputButton } = userRequest
    let text = inputRef.current.value
    ChatController.pushToHistory(userRequest)
    await SmartButtonController.runServerAction(inputButton.buttonWithParams({ text }))
  }

  const postNewMessage = () => {
    let text = inputRef.current.value
    if (text != null && text.trim() != "") {
      postMessage(text)
      inputRef.current.value = ''
      inputRef.current.focus()
    }
  }

  const shareLocation = e => {
    e.preventDefault()
    navigator.geolocation.getCurrentPosition(
      position => {
        postLocation(position.coords)
      },
      error => {
        console.warn('location request failed', error)
      }
    )
  }

  const attachImage = e => {
    e.preventDefault()
    uploadInputRef.current.click()
  }

  const attachmentSelected = e => {
    let file = uploadInputRef.current.files[0]
    if (file)
      postImage(file)
  }

  const scrollToBottom = () => {
    renderedMessagesCountRef.current = messages.length
    if (scrollBoxRef.current)
      scrollBoxRef.current.scrollTop = scrollBoxRef.current.scrollHeight
  }

  let inputButton = userRequest.inputButton || {}
  let respondable = inputButton.action || userRequest.userButton && userRequest.userButton.respondable
  let base = App.state.getObject('base') || '/home'
  let placeholder = inputButton.placeholder || "Add additional information..."

  let lastMessage = _.last(messages)
  if (lastMessage && lastMessage.input_disabled)
    respondable = false
  if(lastMessage && lastMessage.payment_smart_button_id && !lastMessage.paid)
    respondable = false

  return (
    <React.Fragment>
      <div className="chat-messages chat-body-scrollbox" ref={scrollBoxRef} data-user-request-id={userRequest.id}>
        {
          messages == null || messages.length == 0 ?
            <div className="chat-no-messages">No messages yet</div> :
          messages.map(message =>
            <ChatMessage message={message} base={base} key={message.localId} messages={messages} />
          )
        }
      </div>
      {
        respondable &&
        <footer className="chat-typer">
          <hr />
          <div className="chat-input-row">
            <input
              className="form-control chat-input" ref={inputRef} type="text"
              placeholder={placeholder}
              onKeyPress={e => e.key == 'Enter' && submitInput()}
            />
            <button className="btn chat-submit-btn" type="button" onClick={submitInput}>
              <FAIcon icon="faPaperPlane" />
            </button>
          </div>
        </footer>
      }
    </React.Fragment>
  )
}

ChatMessages.propTypes = {
  userRequest: PropTypes.object.isRequired,
  messages: PropTypes.array.isRequired,
  postMessage: PropTypes.func.isRequired,
  postLocation: PropTypes.func.isRequired,
  postImage: PropTypes.func.isRequired,
}

export default ChatMessages
